import React from 'react';
import { Button, Grid2 as Grid, Typography, Container } from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';

import MainFooter from '../../components/layout/MainFooter';

const LastStep = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const img = location.state.status == 'success'
    ? "/Sticker.png"
    : "/Vector.png";
  const title = location.state.status == 'success'
    ? "Cuenta verificada"
    : "Ocurrió un error";
  const subTitle = location.state.status == 'success'
    ? "¡Bienvenido!"
    : "¡Upps! ha ocurrido un error intenta de nuevo.";

  return (
    <Container component="main" maxWidth="md">
      <Grid className="general" container>
        <Grid className="status" container direction="column" alignItems="center" justifyContent="center" xs={6}>
          <img width="150" src={img} alt="Estatus" />
        </Grid>
        <Grid container direction="column" alignItems="center" justifyContent="center">
          <Typography variant="h4">{title}</Typography>
          <Typography variant="h5">{subTitle}</Typography>
          {location.state.status == 'success' &&
            <Typography variant="h5">
              Ya eres parte del círculo de servicios One Service
            </Typography>
          }
        </Grid>
        <Grid size={6} sx={{mt: 3}}>
          <Button
            type="button"
            fullWidth
            variant="contained"
            color="primary"
            onClick={() => navigate('/')}
          >
            Entrar
          </Button>
        </Grid>
      </Grid>
      <MainFooter />
    </Container>
  );
}

export default LastStep;